import { Navigate } from 'react-router-dom'
import { encryptLocalStorage } from "../../config/utils/storage"
import { useEffect, useState } from 'react'
import HTTP from '../../config/axios'

const AuthenticatedRoute = ({ allowedRole, children }: any) => {
    const userInfo = encryptLocalStorage.getItem("userInfo")
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const verifyAuthentication = async () => {
            try {
                const { status } = await HTTP.get("/api/authenticate")
                
                // Check if user is allowed by role UUID or by role weight for admin access
                const isAllowedByRole = allowedRole?.includes(userInfo?.roleUUID);
                const isCrcAdmin = userInfo?.roleWeight === 92; // CRC_ADMIN weight
                const isAdminRoute = Array.isArray(allowedRole) && allowedRole.length >= 8; // Admin routes have multiple roles
                const finalAuthCheck = isAllowedByRole || (isCrcAdmin && isAdminRoute);

            if (status >= 200 && status <= 299 && userInfo && finalAuthCheck) {
                    setIsAuthenticated(true)
                }
            } catch (error) {
                console.error('AuthenticatedRoute - Authentication error:', error);
            } finally {
                setIsLoading(false)
            }
        }
        verifyAuthentication()
    }, [userInfo, allowedRole])

    if (isLoading) {
        // Return a loading indicator or null to prevent rendering children prematurely.
        return null
    }

    if (isAuthenticated) {
        return children
    } else {
        return <Navigate to="/sign-in" />
    }
}

export default AuthenticatedRoute
